import React from 'react'
import { Card } from 'antd'
import { ItemPanel, Item } from 'gg-editor'
import './index.scss'

const FlowItemPanel = (props) => {
  return (
    <ItemPanel className='itemPanel'>
      <Card
        style={{
          minHeight: 808,
          paddingLeft: 18,
          minWidth: 150,
        }}
        bordered={true}
      >
        <div style={{ marginLeft: 4, display: props.role == true ? 'none' : '' }}>
          <Item
            type='node'
            size='72*72'
            shape='flow-circle'
            model={{
              color: '#C2C2C2',
              label: 'Start',
            }}
            src='/ggeditor/flow/start.svg'
          />

          <Item
            type='node'
            size='150*75'
            shape='flow-rect'
            model={{
              // color: '#d9bcff',
              color: '#C2C2C2',
              label: 'Add Task',
            }}
            src='/ggeditor/flow/normal.svg'
          />
          <Item
            type='node'
            size='150*75'
            shape='flow-rhombus'
            model={{
              // color: '#d9bcff',
              color: '#0086C9',
              label: 'Decision',
            }}
            src='/ggeditor/flow/decision.svg'
          />
          <div style={{ marginLeft: 4 }}>
            <Item
              type='node'
              size='72*72'
              shape='flow-circle'
              model={{
                color: '#D92D20',
                label: 'End',
              }}
              src='/ggeditor/flow/end.svg'
            />
          </div>
        </div>
      </Card>
    </ItemPanel>
  )
}

export default FlowItemPanel
